import { render, staticRenderFns } from "./ShadowView.vue?vue&type=template&id=b8952946&scoped=true&"
import script from "./ShadowView.vue?vue&type=script&lang=js&"
export * from "./ShadowView.vue?vue&type=script&lang=js&"
import style0 from "./ShadowView.vue?vue&type=style&index=0&id=b8952946&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8952946",
  null
  
)

export default component.exports